import { render, staticRenderFns } from "./Representantes.vue?vue&type=template&id=a0680afe&"
import script from "./Representantes.vue?vue&type=script&lang=js&"
export * from "./Representantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports